import { useDebounced } from '@lib/hooks'
import type { EditorValue } from '@octopus-do/octopus-editor'
import type { ID } from '@octopus-do/octopus-project-core'
import { LocksActions } from '@store/locksSaga'
import { useDispatch } from 'react-redux'

export const useEditorWrappers = (
  id: ID,
  onChange: (value: EditorValue) => void
) => {
  const dispatch = useDispatch()
  const debounced = useDebounced(onChange, 500)

  const handleChange = (value: EditorValue) => {
    dispatch(LocksActions.lockId({ id }))

    debounced(value)
  }

  return { handleChange }
}
